import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js'

interface Item {
  label: string
  url: string
  info: string
  group: string
  height?: number // 正規化する高さ（省略時は最大寸法2.2）
}

const AV = '語り部・松浦武四郎アバター（Meshy制作）'
const SITE = '寄進地の建造物12棟（Meshy生成）'

const ITEMS: Item[] = [
  { group: AV, label: 'P1 紫羽織・大首飾り — 語り', url: './assets/avatars/p1_talk.glb', info: '本命衣装P1（紫羽織+大首飾り）。Meshyリグ＋語りジェスチャ。VRM 1.0版（表情8種入り）はUnity統合用に納品済み。', height: 1.7 },
  { group: AV, label: 'P1 — お辞儀', url: './assets/avatars/p1_bow.glb', info: 'P1の正式なお辞儀。体験の結び「またこの一畳を訪ねてまいれ」で使用予定。', height: 1.7 },
  { group: AV, label: 'P1 — 立ち話', url: './assets/avatars/p1_chat.glb', info: 'P1の立ち話ジェスチャ（肩下げ補正済み）。生成AI問答シーンの待機動作候補。', height: 1.7 },
  { group: AV, label: 'P2 藍羽織・旅装束 — 語り', url: './assets/avatars/p2_talk.glb', info: '旅装束P2（藍羽織）。蝦夷地を歩いた探検家の顔。屋外パート（山道・空飛ぶ畳）向き。', height: 1.7 },
  { group: AV, label: 'P2 — あぐら', url: './assets/avatars/p2_sit.glb', info: 'P2の床あぐら。一畳敷の中で語るシーン用（正座はBlender手付けを後日）。', height: 1.7 },
  { group: AV, label: 'P2 — 歩き', url: './assets/avatars/p2_walk.glb', info: 'P2の老人らしい歩き（肩下げ補正済み）。山道の先導役。', height: 1.7 },
  { group: AV, label: 'P2 — お辞儀', url: './assets/avatars/p2_bow.glb', info: 'P2の正式なお辞儀。', height: 1.7 },
  { group: AV, label: '旧版（Hunyuan3D・全自動生成）', url: './assets/takeshiro_rigged.glb', info: '画像1枚から全自動生成した初代。ボーン19本＋「Narrate」身振り。P1/P2への置き換え元。', height: 1.7 },
  { group: SITE, label: '42 鉄舟寺（久能寺）— 擬宝珠の床柱', url: './assets/sites3d/42.glb', info: '橋の欄干の擬宝珠を、あえて逆さに吊った床柱のふるさと。' },
  { group: SITE, label: '3 熊野本宮大社 — 雲竜の天井', url: './assets/sites3d/3.glb', info: '桃山期・秀吉造営の扉。金の双眸の雲竜が書斎を見下ろす。' },
  { group: SITE, label: '16 太宰府・水城 — 白鳳の水城材', url: './assets/sites3d/16.glb', info: '664年築の土塁から掘り出された、目録中最古の木。' },
  { group: SITE, label: '60 鵜戸神宮 — 金箔の羽目板', url: './assets/sites3d/60.glb', info: '海蝕洞の朱の社。羽目板の裏に往年の金箔が眠る。' },
  { group: SITE, label: '53 三嶋大社 — 朱漆の南扉', url: './assets/sites3d/53.glb', info: '三重塔の観音開き。朱漆がいまも残る。' },
  { group: SITE, label: '74 大徳寺 — 五老松の板', url: './assets/sites3d/74.glb', info: '裏面に来歴の墨書が現存する名松の板。' },
  { group: SITE, label: '38 吉水神社 — 御垢附の額縁板', url: './assets/sites3d/38.glb', info: '後醍醐天皇行在所。天皇の踏んだ板が畳を縁取る。' },
  { group: SITE, label: '54 大瀬神社 — ビャクシンの鴨居', url: './assets/sites3d/54.glb', info: '樹齢一千五百年の御神木。波のように浸食された木肌。' },
  { group: SITE, label: '34 鶴岡八幡宮 — 舞殿の木鼻', url: './assets/sites3d/34.glb', info: '静御前の舞の記憶。牡丹の彫刻。' },
  { group: SITE, label: '85 法隆寺 — 棚板', url: './assets/sites3d/85.glb', info: '日本最古の木造建築の記憶を書棚に。' },
  { group: SITE, label: '4 厳島神社 — 大鳥居の書棚戸', url: './assets/sites3d/4.glb', info: '平清盛の大鳥居の楠（現存せず・語りのみ）。' },
  { group: SITE, label: '84 熊野速玉大社 — 弁慶楠の板', url: './assets/sites3d/84.glb', info: '「弁慶がこの楠から生まれた」——武四郎自身も眉唾と笑った伝承。' },
]

const app = document.getElementById('app')!
const select = document.getElementById('modelSelect') as HTMLSelectElement
const spin = document.getElementById('spin') as HTMLInputElement
const info = document.getElementById('info')!

const renderer = new THREE.WebGLRenderer({ antialias: true })
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.setSize(window.innerWidth, window.innerHeight)
app.appendChild(renderer.domElement)

const scene = new THREE.Scene()
scene.background = new THREE.Color(0x10141b)

const camera = new THREE.PerspectiveCamera(50, window.innerWidth / window.innerHeight, 0.05, 100)
camera.position.set(0, 1.6, 3.4)
const controls = new OrbitControls(camera, renderer.domElement)
controls.target.set(0, 1.0, 0)
controls.enableDamping = true

scene.add(new THREE.HemisphereLight(0xfff2dc, 0x2a3442, 1.2))
const key = new THREE.DirectionalLight(0xffe8c0, 2.2)
key.position.set(3, 5, 4)
scene.add(key)
const rim = new THREE.PointLight(0x9fc3ff, 20, 20)
rim.position.set(-3, 3, -3)
scene.add(rim)

const floor = new THREE.Mesh(
  new THREE.CircleGeometry(6, 48),
  new THREE.MeshStandardMaterial({ color: 0x1a202b, roughness: 0.9 }),
)
floor.rotation.x = -Math.PI / 2
scene.add(floor)

const turntable = new THREE.Group()
scene.add(turntable)

const loader = new GLTFLoader()
loader.setMeshoptDecoder(MeshoptDecoder) // P1/P2はmeshopt圧縮GLB
let mixer: THREE.AnimationMixer | undefined
let token = 0

async function show(i: number): Promise<void> {
  const my = ++token
  const item = ITEMS[i]
  info.textContent = '読み込み中…'
  try {
    const gltf = await loader.loadAsync(item.url)
    if (my !== token) return
    turntable.clear()
    mixer = undefined
    const model = gltf.scene
    const b = new THREE.Box3().setFromObject(model)
    const size = b.getSize(new THREE.Vector3())
    const s = item.height ? item.height / Math.max(size.y, 0.01) : 2.2 / Math.max(size.x, size.y, size.z, 0.01)
    model.scale.setScalar(s)
    const b2 = new THREE.Box3().setFromObject(model)
    const c2 = b2.getCenter(new THREE.Vector3())
    model.position.set(-c2.x, -b2.min.y, -c2.z)
    turntable.add(model)
    if (gltf.animations.length > 0) {
      mixer = new THREE.AnimationMixer(model)
      const clip = gltf.animations.find((c) => /narrate/i.test(c.name)) ?? gltf.animations[0]
      mixer.clipAction(clip).setLoop(THREE.LoopRepeat, Infinity).play()
    }
    info.textContent = item.info
  } catch {
    if (my === token) info.textContent = 'モデルの読み込みに失敗しました'
  }
}

let currentGroup: HTMLOptGroupElement | undefined
ITEMS.forEach((item, i) => {
  if (!currentGroup || currentGroup.label !== item.group) {
    currentGroup = document.createElement('optgroup')
    currentGroup.label = item.group
    select.appendChild(currentGroup)
  }
  const o = document.createElement('option')
  o.value = String(i)
  o.textContent = item.label
  currentGroup.appendChild(o)
})
select.addEventListener('change', () => void show(Number(select.value)))
void show(0)

window.addEventListener('resize', () => {
  camera.aspect = window.innerWidth / window.innerHeight
  camera.updateProjectionMatrix()
  renderer.setSize(window.innerWidth, window.innerHeight)
})

const clock = new THREE.Clock()
renderer.setAnimationLoop(() => {
  const dt = Math.min(clock.getDelta(), 0.1)
  if (spin.checked) turntable.rotation.y += dt * 0.4
  mixer?.update(dt)
  controls.update()
  renderer.render(scene, camera)
})
